import { createThunk, model, Model, view } from 'mst-collection';
import { getRoot, types } from 'mobx-state-tree';

import { useRoot } from '../useRoot';
import { TutorialListModel } from './TutorialListModel';
import { CategoriesModel } from './CategoriesModel';
import { Api, schemas } from '@api';
import { Tutorial } from './TutorialModel';
import { RelatedTutorialListModel } from './RelatedTutorialListModel';
import { SearchedTutorialListModel } from './SearchedTutorialListModel';
import type { RootModelType } from '../RootModel';

export class Tutorials extends Model({
  list: types.optional(TutorialListModel, {}),
  categories: types.optional(CategoriesModel, {}),
  related: types.optional(RelatedTutorialListModel, {}),
  searched: types.optional(SearchedTutorialListModel, {}),
}) {
  // TODO: move it into TutorialCollectionModel
  fetchById = createThunk((id: number) => {
    return async function fetchById(flow) {
      const res = await Api.Hub.getTutorialById({ id });

      flow.merge(res.data, schemas.TutorialSchema);
    };
  });

  // TODO: move it into TutorialCollectionModel
  @view
  getById(id: number): Tutorial | undefined {
    return getRoot<RootModelType>(this).entities.tutorials.get(id);
  }
}

export const TutorialsModel = model(Tutorials);

export function useTutorialsModel() {
  const root = useRoot();

  return root.tutorial;
}
